/**
 * VAT (TVA) Constants
 * Belgian VAT rates as of 2025
 */

/**
 * VAT Rates as decimal values (for calculations)
 */
export const VAT_RATES = {
  STANDARD: 0.21,      // 21% - Standard rate for most goods and services
  REDUCED: 0.12,       // 12% - Reduced rate for specific goods
  SUPER_REDUCED: 0.06, // 6% - Super-reduced rate for essential goods
  ZERO: 0              // 0% - Zero rate / exempt
} as const;

/**
 * VAT Rates as percentage values (for display)
 */
export const VAT_RATES_PERCENT = {
  STANDARD: 21,
  REDUCED: 12,
  SUPER_REDUCED: 6,
  ZERO: 0
} as const;
